module.exports = __webpack_public_path__ + "img/user.b6b940f3.svg";